import { Button, Icon, Spacer } from '@hover/blueprint';
import { iCheck, iCircle } from '@hover/icons';
import type { MouseEventHandler, ReactNode } from 'react';
import React, { forwardRef } from 'react';

interface ColorPopoverButtonProps {
  children: ReactNode;
  selected?: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
  label: string;
  labelColor?: string;
}
const PopoverColorButton = forwardRef<
  HTMLButtonElement,
  ColorPopoverButtonProps
>(({ children, label, labelColor = '', onClick, selected }, ref) => (
  <Button
    fill="minimal"
    iconBefore={selected ? iCheck : undefined}
    label={label}
    onClick={onClick}
    paddingLeft={0}
    paddingRight={0}
    ref={ref}
    shape="box"
    width="full"
  >
    {children}
    <Spacer />
    {labelColor ? (
      <Icon color={labelColor} fill={labelColor} icon={iCircle} />
    ) : null}
  </Button>
));

export { PopoverColorButton, ColorPopoverButtonProps };
